import { shape, string } from 'prop-types'

export const CustomField = shape({
  key: string.isRequired,
  label: string.isRequired
})
